import React, { Fragment } from 'react';
import styled from 'styled-components';
import Styles from './ModalToSelectSeats.Styles';
import Text from '../../base/Text';
import ValidateButton from '../../compound/TicketsWhite/ValidateButton';
import car_seat_icon_gray from '../../../assets/images/Shuttle/car_seat_icon_gray.png';
import car_seat_icon_pink from '../../../assets/images/Shuttle/car_seat_icon_pink.png';
import car_seat_icon_purple from '../../../assets/images/Shuttle/car_seat_icon_purple.png';

const Header = styled.div`${Styles.header}`; // prettier-ignore
const Body = styled.div`${Styles.body}`; // prettier-ignore
const Title = styled.h3`${Styles.title}`; // prettier-ignore
const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const TypeColor = styled.div`${Styles.typeColor}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;


const ModalToSelectSeats = ({
    onSelectedSeat,
    selectedSeat,
    openModalSelectedSeats,
    translations,
    goToPersonalInfo,
    shuttlePassengers,
    selectedCounter,
    page
}) => {

    let shuttleDetails = {data:{passengersS:{}}};
    if (typeof window !== 'undefined') {
        if(page === 'shuttleSelectSeatsReturn'){
            shuttleDetails =  JSON.parse(window.localStorage.getItem('CBX_Shuttle_Return_Details'));
        }else{        
            shuttleDetails =  JSON.parse(window.localStorage.getItem('CBX_Shuttle_Details'));
        }
    }

    let purple = "invert(16%) sepia(22%) saturate(1604%) hue-rotate(227deg) brightness(94%) contrast(90%)";
    let gray = "invert(100%) sepia(0%) saturate(5050%) hue-rotate(200deg) brightness(88%) contrast(91%)";
    let pink = "invert(52%) sepia(65%) saturate(1339%) hue-rotate(300deg) brightness(92%) contrast(91%)";


    const Seat = ({ id, onSelectedSeat, isAvailable }) => {

        let seats = [...selectedSeat];
        const found = seats.find(element => element === id);

        const select = (id) => {
            if (seats.length < shuttlePassengers) {
                if (found != id) {
                    seats.push(id);
                    onSelectedSeat(seats)
                }
            } else {
                //Modificar el residuo de (seleccionados % shuttlePassengers)
                seats[selectedCounter % shuttlePassengers] = id;
                onSelectedSeat(seats);
                //console.log("ya no se pueden selecionar mas asientos");
            }
            if (found === id) {
                seats.splice(seats.indexOf(id), 1);
                onSelectedSeat(seats)

            }
        };

        return (
            <img alt="Seat"
                src={!isAvailable ? car_seat_icon_pink : found ? car_seat_icon_purple : car_seat_icon_gray}
                id={id}
                width={23}
                height={25}
                onClick={() => isAvailable && select(id)}
                style={{
                     cursor: 'pointer', marginBottom: "5px"
                }}
                 />
        )
    };

    const SeatColumn = ({ columnData }) => {
        const seats = Object.keys(columnData);
        return seats.map(index => {
            const numberSeat = columnData[index].seatNumber;
            const isAvailable = columnData[index].isAvailable;
            return (
                <Column>
                    <Seat id={numberSeat} isAvailable={isAvailable} onSelectedSeat={onSelectedSeat} />
                    {index > 0 && index % 3 === 0 && <div style={{ marginTop: "2px", width: "25px", height: "20px" }} />}
                </Column>
            )
        })
    }

    let letters = Object.keys(shuttleDetails.data.passengersS);
    let totalSeats = shuttleDetails.data.totalSeats;
    if(!letters) letters = [];
    if(!totalSeats) totalSeats = 1;
    const seats = letters.map(letter => {
        const columnData = shuttleDetails.data.passengersS[letter];
        return (
            <div style={{
                padding: "5px",
                paddingBottom: "10px",
                marginBottom: "10px",
            }}>
                <SeatColumn columnData={columnData} />
            </div>
        )
    });
    
    return (
        <Fragment style={{ flex: 1 }} onClick={openModalSelectedSeats}>
            <Header border>
                <Title className="cbx-bold"></Title>
            </Header>
            <Body>
                <p style={{ marginLeft: "80px", color: "rgb(239, 96, 163)", fontWeight: "bolder", fontSize: 18, marginBottom: 0 }}>{translations.selectYourSeat}</p>
                <p style={{ marginLeft: "80px", color: "#D8D8D8", fontWeight: "bolder", fontSize: 14 }}>{translations.avalaibleSeat} {totalSeats - selectedSeat.length}</p>
                <Row style={{ justifyContent: "center" }}>
                    <Column>
                        <Row>
                            {letters.map(letter => <Text style={{ margin: "6px", width: "25px", fontWeight: "bold", color: "#D8D8D8" }}>{letter}</Text>)}
                        </Row>
                        <Row style={{ marginTop: "20px" }}>{seats}</Row>
                    </Column>
                    <Column style={{
                        alignSelf: "flex-start",
                        margin: "15% 5% 14% 15%"
                    }}>
                        <Row>
                            <TypeColor color={"gray"} />
                            <Text style={{ color: "#3F2A55", fontSize: 15, }}>{translations.available}</Text>
                        </Row>
                        <Row>
                            <TypeColor color={"rgb(239, 96, 163)"} />
                            <Text style={{ color: "#3F2A55", fontSize: 15, }}>{translations.occupied}</Text>
                        </Row>
                        <Row>
                            <TypeColor color={"#3F2A55"} />
                            <Text style={{ color: "#3F2A55", fontSize: 15, }}>{translations.selectSeat}</Text>
                        </Row>
                        <Row>
                            <Text style={{
                                color: "#3F2A55", fontWeight: 600, fontSize: 20,
                                textAlign: "end", marginTop: "20px", fontFamily: "Open Sans ,sans-serif"
                            }}
                            >{translations.seat}{shuttlePassengers < 2 ? "" : "s"}: </Text>
                            <Text style={{
                                color: "#3F2A55", fontWeight: 600, fontSize: 20,
                                textAlign: "end", marginTop: "20px", fontFamily: "Open Sans ,sans-serif",
                                height: "auto"
                            }}
                            >{selectedSeat.toString()} </Text>
                        </Row>
                    </Column>
                </Row>
                <ButtonContainer >
                    <ValidateButton
                        disabled={shuttlePassengers > selectedSeat.length}
                        action={goToPersonalInfo}
                        message={translations.continueLabel}
                    />
                </ButtonContainer>
            </Body>
        </Fragment>
    );
};

export default ModalToSelectSeats;




